






















































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { EState, IDropDown } from './NewFeedLayout.vue'

@Component
export default class MobileButtonArea extends Vue {
  @Prop() actionAreaState!: EState
  @Prop() roleEditTopic!: boolean
  @Prop() isSelectAnyItem!: boolean
  @Prop() private checkAll!: boolean
  @Prop() sortSelected!: any
  @Prop() sortOptions!: IDropDown[]
  @Prop() folderSelected!: any
  @Prop() folderOptions!: IDropDown[]
  @Prop() topicLength!: number

  checkAllClone: boolean = this.checkAll
  isCommonTopic = !this.$route.params.groupId
  eState = EState

  @Watch('checkAll')
  watchCheckAll() {
    this.checkAllClone = this.checkAll
  }

  handleMoveToUnclassified(isFromBin: boolean) {
    this.$emit('handleMoveToUnclassified', isFromBin)
  }

  openConfirmDeleteBin(isFromBin: boolean) {
    this.$emit('openConfirmDeleteBin', isFromBin)
  }

  handleSortChange(index: number) {
    this.$emit('handleSortChange', index)
  }

  handleSelectFolder(index: number) {
    this.$emit('handleSelectFolder', index)
  }

  handleCheckAll() {
    this.$emit('handleCheckAll', this.checkAllClone)
  }

  jumpToCreateTopicPage() {
    this.$emit('jumpToCreateTopicPage')
  }

  openEditFolderModal() {
    this.$emit('openEditFolderModal')
  }

  pinMultipleTopics() {
    this.$emit('pinMultipleTopics')
  }
}
